
export const PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)\S{8,20}$/;
